import SubmissionTranslator from "../../../utils/SubmissionTranslator";

const translator = new SubmissionTranslator("pharmacy");

// Order of columnSchema must match order of columnDetails
export const columnSchema = {
  contracted_entity_id: null,
  date_of_service: null,
  date_prescribed: null,
  ndc: null,
  quantity: null,
  rx_number: null,
  service_provider_id: null,
  service_provider_id_qualifier: null,
  prescriber_id: null,
  prescriber_id_qualifier: null,
  wholesaler_invoice_number: null,
  payer_bin: null,
  payer_pcn: null,
  ship_to_location: null,
  ship_to_date: null,
  account_340b: null,
  product_serialization_number: null,
  fill_number: null,
  formatted_rx_number: null,
};

export const columnDetails = [
  {
    name: "contracted_entity_id",
    title: translator.getTitle("contracted_entity_id"),
    label: translator.getLabel("contracted_entity_id"),
    description: translator.getDescription("contracted_entity_id"),
    required: true,
    order: 1,
  },
  {
    name: "date_of_service",
    title: translator.getTitle("date_of_service"),
    label: translator.getLabel("date_of_service"),
    description: translator.getDescription("date_of_service"),
    required: true,
    order: 2,
  },
  {
    name: "date_prescribed",
    title: translator.getTitle("date_prescribed"),
    label: translator.getLabel("date_prescribed"),
    description: translator.getDescription("date_prescribed"),
    required: true,
    order: 3,
  },
  {
    name: "ndc",
    title: translator.getTitle("ndc"),
    label: translator.getLabel("ndc"),
    description: translator.getDescription("ndc"),
    required: true,
    order: 4,
  },
  {
    name: "quantity",
    title: translator.getTitle("quantity"),
    label: translator.getLabel("quantity"),
    description: translator.getDescription("quantity"),
    required: true,
    order: 5,
  },
  {
    name: "rx_number",
    title: translator.getTitle("rx_number"),
    label: translator.getLabel("rx_number"),
    description: translator.getDescription("rx_number"),
    required: true,
    order: 6,
  },
  {
    name: "service_provider_id",
    title: translator.getTitle("service_provider_id"),
    label: translator.getLabel("service_provider_id"),
    description: translator.getDescription("service_provider_id"),
    required: true,
    order: 7,
  },
  {
    name: "service_provider_id_qualifier",
    title: translator.getTitle("service_provider_id_qualifier"),
    label: translator.getLabel("service_provider_id_qualifier"),
    description: translator.getDescription("service_provider_id_qualifier"),
    required: false,
    order: 8,
  },
  {
    name: "prescriber_id",
    title: translator.getTitle("prescriber_id"),
    label: translator.getLabel("prescriber_id"),
    description: translator.getDescription("prescriber_id"),
    required: false,
    order: 9,
  },
  {
    name: "prescriber_id_qualifier",
    title: translator.getTitle("prescriber_id_qualifier"),
    label: translator.getLabel("prescriber_id_qualifier"),
    description: translator.getDescription("prescriber_id_qualifier"),
    required: false,
    order: 10,
  },
  {
    name: "wholesaler_invoice_number",
    title: translator.getTitle("wholesaler_invoice_number"),
    label: translator.getLabel("wholesaler_invoice_number"),
    description: translator.getDescription("wholesaler_invoice_number"),
    required: false,
    order: 11,
  },
  {
    name: "payer_bin",
    title: translator.getTitle("payer_bin"),
    label: translator.getLabel("payer_bin"),
    description: translator.getDescription("payer_bin"),
    required: false,
    order: 12,
  },
  {
    name: "payer_pcn",
    title: translator.getTitle("payer_pcn"),
    label: translator.getLabel("payer_pcn"),
    description: translator.getDescription("payer_pcn"),
    required: false,
    order: 13,
  },
  {
    name: "ship_to_location",
    title: translator.getTitle("ship_to_location"),
    label: translator.getLabel("ship_to_location"),
    description: translator.getDescription("ship_to_location"),
    required: false,
    order: 14,
  },
  {
    name: "ship_to_date",
    title: translator.getTitle("ship_to_date"),
    label: translator.getLabel("ship_to_date"),
    description: translator.getDescription("ship_to_date"),
    required: false,
    order: 15,
  },
  {
    name: "account_340b",
    title: translator.getTitle("account_340b"),
    label: translator.getLabel("account_340b"),
    description: translator.getDescription("account_340b"),
    required: false,
    order: 16,
  },
  {
    name: "product_serialization_number",
    title: translator.getTitle("product_serialization_number"),
    label: translator.getLabel("product_serialization_number"),
    description: translator.getDescription("product_serialization_number"),
    required: false,
    order: 17,
  },
  {
    name: "fill_number",
    title: translator.getTitle("fill_number"),
    label: translator.getLabel("fill_number"),
    description: translator.getDescription("fill_number"),
    required: false,
    order: 18,
  },
];

export const computedColumns = ["formatted_rx_number"];

export const tableHeaders = columnDetails.sort((a, b) => a.order - b.order).map((col) => col.name);
export const sortedColumnDetails = columnDetails.sort((a, b) => a.order - b.order);
export const required = columnDetails.filter((col) => col.required).map((col) => col.name);
export const notRequired = columnDetails.filter((col) => !col.required).map((col) => col.name);

export const isRequiredField = (column) => required.includes(column);

export const columnNameAliases = {
  date_of_service: [
    "Date Of Service",
    "Fill Date",
    "date_of_service",
    "Dispensed",
    "Fill Sold Date",
    "Service Date",
    "Date of Service (Fill Date)",
    "Rx Fill Date",
    "DOS (Date of Service)",
    "Date Filled",
    "Dispense Date",
  ],
  date_prescribed: [
    "Date Prescribed",
    "Rx Written Date",
    "date_prescribed",
    "Written Date",
    "Date Prescription Written",
    "Prescribed Date",
    "Date Written",
    "RX-Date Written",
    "Script Written Date",
    "Date RxWritten",
    "Date Rx Written",
  ],
  rx_number: [
    "Rx number",
    "Prescription Number",
    "Service Reference Number",
    "Rx Nbr",
    "rx_number",
    "Prescription_Number",
    "Rx #",
    "RX NBR",
  ],
  ndc: [
    "Dispensed Item NDC",
    "Dispensed NDC",
    "Dispensed NDC11",
    "NDC",
    "NDC 11",
    "NDC Number",
    "NDC-11",
    "Product",
    "Product Service ID",
    "Service ID",
  ],
  quantity: [
    "Quantity",
    "Qty Disp",
    "Qnty",
    "Qty Dispensed",
    "Qty",
    "Dispensed Quantity",
    "Dispense Qty",
    "Qty_Dispensed",
  ],
  wholesaler_invoice_number: [
    "Wholesaler Invoice Number",
    "Wholesaler PO",
    "Invoice Number",
    "Wholesaler Invoice #",
    "Invoice #",
    "replenished order number",
  ],
  prescriber_id_qualifier: [
    "Prescriber ID Qualifier",
    "prescriber_id_qualifier",
    "Prescriber Qualifier",
    "Provider ID type",
  ],
  prescriber_id: [
    "Prescriber ID",
    "prescriber npi",
    "Prescriber DEA",
    "prescriber_id",
    "PrescriberNPIorDEA",
    "Prescriber NPI Or Dea",
  ],
  service_provider_id_qualifier: [
    "Service Provider ID Qualifier",
    "Provider ID Qualifier",
    "service_provider_id_qualifier",
    "Pharmacy Qualifier",
    "Service Provider ID Qualifier NCPDP_NABP",
    "Service provider ID type",
    "Pharmacy NPI Qualifier",
  ],
  service_provider_id: [
    "Service Provider ID",
    "service_provider_id",
    "Service Provider ID NPI",
    "Pharmacy #",
    "Service Provider ID NCPDP_NABP",
    "Pharmacy DEA",
    "Ph NCPDP",
    "Pharmacy NCPDP",
    "Pharmacy NPI",
    "Prescriber NPI",
    "facility_opa_340b_id",
    "Store NPI",
  ],
  contracted_entity_id: [
    "Contracted Entity ID",
    "Contracted Entity",
    "OPA Code",
    "HRSA #",
    "Entity ID",
    "contracted_entity_id",
    "CE ID",
    "340B ID",
  ],
  payer_bin: ["Payer BIN", "BIN", "payer_bin"],
  payer_pcn: ["Payer PCN", "PCN", "payer_pcn"],
  ship_to_date: ["Ship to date", "Ship date", "ship_to_date"],
  ship_to_location: ["Ship to location", "Ship location", "ship_to_location"],
  account_340b: ["340b Account", "Account 340b", "account_340b", "340b_account"],
  product_serialization_number: [
    "Product Serialization Number",
    "Serial Number",
    "product_serialization_number",
    "product_serial_num",
    "product_serialization_num",
    "serialization_number",
    "serial_number",
  ],
  fill_number: ["Fill Number", "fill_number", "fill_num", "Fill Num"],
};
